// extracted by mini-css-extract-plugin
export default {"container":"TournamentsConsole_container__rSM9x","tabs":"TournamentsConsole_tabs__3Xose","activeTab":"TournamentsConsole_activeTab__vWaFE"};